export default "__VITE_ASSET__08adb595__"